import { DatePicker, Form, Select } from "antd"
import React, { useEffect } from "react"
import FloatingLabelInput from "../../FloatingLabelInput/FloatingLabelInput"
import GenderToggle from "../../GenderToggle/GenderToggle"
import { uniqBy } from "lodash"
import countriesArray from "config/countryArr"
import VirtualizedSelect from "react-virtualized-select"
import moment from "moment"

var CodiceFiscale = require("codice-fiscale-js")

const { Option } = Select

function Step1({ form, formData, setFormData }) {
  const { getFieldDecorator } = form

  const dateFormat = "DD/MM/YYYY"

  const handleNazione = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      nazione: e,
    }))
  }

  const handleInputChange = (field) => (e) => {
    e.persist()
    setFormData((prevState) => ({
      ...prevState,
      [field]: e.target.value,
    }))
  }

  const allNazione = uniqBy(countriesArray, "nazione")

  const nazioneList = []
  if (allNazione && allNazione.length > 0) {
    for (let i = 0; i < allNazione.length; i++) {
      nazioneList.push(
        <Option key={allNazione[i].nazione} value={allNazione[i].nazione}>
          {allNazione[i].nazione}
        </Option>
      )
    }
  }

  let city_of_birth = []
  if (countriesArray) {
    const currentNazione = (formData.nazione || "").toUpperCase()
    city_of_birth = countriesArray
      .filter((items) => items.nazione === currentNazione)
      .map((items) => ({
        label: items.provincia,
        value: items.provincia,
        codeKey: items.codeKey,
      }))
  }

  const validateCodiceFiscale = (e) => {
    const codFisInps = e
    const str = codFisInps

    const fiscalCodeKey = str.substring(str.length - 5, str.length - 1)
    const sexKey = parseInt(str.substring(9, 11), 10)
    const yearBKey = str.substring(6, 8)
    const monthBKey = str.substring(8, 9)

    let month = ""
    let year = 1900 + parseInt(yearBKey, 10)
    let day = sexKey % 40

    const monthMap = {
      A: "01",
      B: "02",
      C: "03",
      D: "04",
      E: "05",
      H: "06",
      L: "07",
      M: "08",
      P: "09",
      R: "10",
      S: "11",
      T: "12",
    }

    month = monthMap[monthBKey.toUpperCase()]

    if (sexKey > 40) {
      setFormData((prevState) => ({
        ...prevState,
        gender: "F",
      }))
    } else {
      setFormData((prevState) => ({
        ...prevState,
        gender: "M",
      }))
    }

    form.setFieldsValue({
      birthday: moment(`${day}-${parseInt(month)}-${year}`, "DD-MM-YYYY"),
    })

    setFormData((prevState) => ({
      ...prevState,
      birthday: moment(`${day}-${parseInt(month)}-${year}`, "DD-MM-YYYY"),
    }))

    countriesArray
      .filter((comune) => comune.codeKey.toString() === fiscalCodeKey.toString())
      .map((comune) => {
        setFormData((prevState) => ({
          ...prevState,
          comuniSelected: comune,
          nazione: comune.nazione,
          province_of_birth: comune.sigla,
          city_of_birth: comune.provincia,
        }))

        return comune
      })
  }

  useEffect(() => {
    if (formData.birthday && formData.nazione === "ITALIA") {
      const parsedBirthday = moment(formData.birthday, "DD/MM/YYYY", true)

      if (
        parsedBirthday.isValid() &&
        formData.first_name &&
        formData.last_name &&
        formData.gender &&
        formData.city_of_birth &&
        formData.province_of_birth
      ) {
        const day = parsedBirthday.date()
        const month = parsedBirthday.month() + 1
        const year = parsedBirthday.year()

        try {
          const cf = new CodiceFiscale({
            name: formData.first_name,
            surname: formData.last_name,
            gender: formData.gender,
            day,
            month,
            year,
            birthplace: formData.city_of_birth,
            province: formData.province_of_birth,
          })

          setFormData((prevState) => ({
            ...prevState,
            codice_fiscale: cf.code,
          }))
        } catch (err) {
          console.error(
            "Errore generando codice fiscale:",
            err instanceof Error ? err : String(err)
          )
          setFormData((prevState) => ({
            ...prevState,
            codice_fiscale: "",
          }))
        }
      } else {
        console.warn("Invalid data for codice fiscale generation:", formData)
        setFormData((prevState) => ({
          ...prevState,
          codice_fiscale: "",
        }))
      }
    }
  }, [
    formData.first_name,
    formData.last_name,
    formData.gender,
    formData.birthday,
    formData.nazione,
    formData.city_of_birth,
    formData.province_of_birth,
  ])

  return (
    <>
      <Form.Item hasFeedback>
        {getFieldDecorator("codice_fiscale", {
          initialValue: formData.codice_fiscale,
          rules: [
            {
              validator: (rule, value, callback) => {
                const currentNazione = form.getFieldValue("nazione")
                if (currentNazione === "ITALIA") {
                  if (!value || !value.trim()) {
                    callback("Inserire codice fiscale!")
                    return
                  }
                  const pattern =
                    /^[A-Z]{6}\d{2}[A-EHLMPRST]{1}\d{2}[A-Z]{1}\d{3}[A-Z]{1}$/
                  if (!pattern.test(value.toUpperCase())) {
                    callback(
                      "Codice fiscale non valido! Deve essere nel formato corretto."
                    )
                    return
                  }
                }
                callback()
              },
            },
          ],
        })(
          <FloatingLabelInput
            label="Codice Fiscale"
            onChange={(e) => {
              validateCodiceFiscale(e.target.value)

              handleInputChange("codice_fiscale")(e)
            }}
          />
        )}
      </Form.Item>

      <Form.Item hasFeedback style={{ marginBottom: "-17px" }}>
        {getFieldDecorator("first_name", {
          initialValue: formData.first_name,
          rules: [{ required: true, message: "Inserire nome!", whitespace: true }],
        })(
          <FloatingLabelInput
            label="Nome"
            onChange={(e) => {
              handleInputChange("first_name")(e)
            }}
          />
        )}
      </Form.Item>

      <Form.Item hasFeedback>
        {getFieldDecorator("last_name", {
          initialValue: formData.last_name,
          rules: [{ required: true, message: "Inserire cognome!" }],
        })(
          <FloatingLabelInput
            label="Cognome"
            onChange={(e) => {
              handleInputChange("last_name")(e)
            }}
          />
        )}
      </Form.Item>

      <Form.Item hasFeedback>
        {getFieldDecorator("email", {
          initialValue: formData.email,
          rules: [
            { type: "email", message: "E-mail non valido!" },
            { required: true, message: "Inserire E-mail!" },
          ],
        })(
          <FloatingLabelInput
            label="Email"
            onChange={(e) => {
              handleInputChange("email")(e)
            }}
          />
        )}
      </Form.Item>

      <Form.Item hasFeedback>
        {getFieldDecorator("number", {
          initialValue: formData.number,
          rules: [{ required: true, message: "Inserire numero telefono!" }],
        })(
          <FloatingLabelInput
            label="Telefono"
            onChange={(e) => {
              handleInputChange("number")(e)
            }}
          />
        )}
      </Form.Item>

      <Form.Item>
        {getFieldDecorator("gender", {
          initialValue: formData.gender,
          rules: [{ required: true, message: "Inserire sesso!" }],
        })(
          <GenderToggle
            initialGender={formData.gender}
            onGenderChange={(gender) => {
              setFormData((prevState) => ({
                ...prevState,
                gender: gender,
              }))
            }}
          />
        )}
      </Form.Item>

      <Form.Item style={{ marginBottom: "16px" }}>
        {getFieldDecorator("birthday", {
          initialValue:
            formData.birthday !== "" &&
            moment(formData.birthday, dateFormat).isValid()
              ? moment(formData.birthday, dateFormat)
              : null,
          rules: [
            {
              required: true,
              message: "Inserisci data di nascita",
            },
          ],
        })(
          <DatePicker
            placeholder="Data di nascita"
            format={("DD/MM/YYYY", "DD/MM/YYYY")}
            onChange={(date) => {
              const formattedDate = date ? date.format(dateFormat) : ""
              setFormData((prevState) => ({
                ...prevState,
                birthday: formattedDate,
              }))
            }}
          />
        )}
      </Form.Item>
      <Form.Item hasFeedback style={{ marginBottom: "16px" }}>
        {getFieldDecorator("nazione", {
          initialValue: formData.nazione || undefined,
          rules: [{ required: true, message: "Seleziona nazione!" }],
        })(
          <Select
            showSearch
            placeholder="Seleziona nazione"
            optionFilterProp="children"
            onChange={(value) => {
              setFormData((prev) => ({ ...prev, nazione: value }))

              form.setFields({
                codice_fiscale: {
                  value: form.getFieldValue("codice_fiscale"),
                  errors: [],
                },
              })
            }}
            allowClear
          >
            {nazioneList}
          </Select>
        )}
      </Form.Item>

      <Form.Item hasFeedback style={{ marginBottom: "16px" }}>
        <VirtualizedSelect
          placeholder="Comune di nascita"
          options={city_of_birth}
          onChange={(city_of_birth) =>
            setFormData((prevState) => ({
              ...prevState,
              city_of_birth: city_of_birth.value,
              country_code: city_of_birth.codeKey,
            }))
          }
          value={formData.city_of_birth}
          maxHeight={100}
        />
      </Form.Item>
    </>
  )
}

export default Step1
